/**
 * Defines the environment of the API domains.
 *
 * @public
 */
export enum Environment {
  PRODUCTION = "PRODUCTION",
  SANDBOX = "SANDBOX",
}
